import baseUrlWithNoForwardSlash from "./baseUrl";
import axios from "axios";

export default class companiesApiServices {
    axios;

  constructor() {
    this.axios = axios;
  }

  getList(searchParams) {
    if (searchParams) {
      return this.axios.get(`${baseUrlWithNoForwardSlash}/companies`, {
        params: {
          ...searchParams
        }
      });
    }
    return this.axios.get(`${baseUrlWithNoForwardSlash}/companies`);
  }

  get(id) {
    return this.axios.get(`${baseUrlWithNoForwardSlash}/companies/${id}`);
  }

  post(dto) {
    return this.axios.post(`${baseUrlWithNoForwardSlash}/companies`, {...dto});
  }

  put(dto) {
    return this.axios.put(`${baseUrlWithNoForwardSlash}/companies`, {...dto});
  }

  restore(id) {
    return this.axios.put(`${baseUrlWithNoForwardSlash}/companies/${id}`);
  }

  delete(id) {
    return this.axios.delete(`${baseUrlWithNoForwardSlash}/companies/${id}`);
  }
}